import { Injectable } from '@angular/core';
import { FitApiClientService, FitList } from '@shared/fit-api-client.service';
import { unwrapAdminListItems } from '@shared/admin-list-response.util';

export interface EquipmentBasicData {
    id: number;
    name: string;
}

@Injectable({ providedIn: 'root' })
export class EquipmentService {
    constructor(private fitApi: FitApiClientService) { }

    public search(query: string, page: number) {
        return this.fitApi.get<FitList<EquipmentBasicData>>('/admin/equipment', {
            search: query,
            page: page.toString()
        });
    }

    public all() {
        return this.fitApi.get<Record<string, unknown>>('/admin/equipment/list').then(({ data, error }) => ({
            data: unwrapAdminListItems<EquipmentBasicData>(data, ['equipment']),
            error,
        }));
    }

    public get(id: number) {
        return this.fitApi.get<EquipmentBasicData>('/admin/equipment/' + id);
    }

    public create(equipment: EquipmentBasicData) {
        return this.fitApi.put<EquipmentBasicData>('/admin/equipment/0', equipment);
    }

    public update(equipment: EquipmentBasicData) {
        return this.fitApi.put<EquipmentBasicData>('/admin/equipment/' + equipment.id, equipment);
    }

    public delete(id: number) {
        return this.fitApi.delete<any>('/admin/equipment/' + id);
    }

}
